var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-select p-select--month"},[_c('dropdown-select',{attrs:{"name":_vm.name,"list":_vm.monthList,"value":("" + _vm.value),"wrapperClass":"u-full"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }